export const isHit = ({ result, sides }) => result >= sides - 1;
export const isGlitch = ({ result }) => result === 1;



// WEBPACK FOOTER //
// ./src/utils.js